/* eslint-disable max-len */

import { t } from '@/main';

export class PricingCalculatorType {
  public static createEmpty(): PricingCalculatorType {
    return new PricingCalculatorType();
  }
  constructor(
    public Id: number = 0,
    public Name: string = '',
    public Heading: string = '',
    public Line1: string = '',
    public Line2: string = '',
    public Line3: string = '',
    public Line4: string = '',
    public Line5: string = '',
    public Line6: string = '',
    public Line7: string = '',
    public Line8: string = '',
  ) { }
}
export class PricingCalculatorTypes extends PricingCalculatorType {
  public arrPricingCalculatorTypes: PricingCalculatorType[] = [];
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  constructor(rootObj: any, $store: any, $t: any) {
    super();

    this.arrPricingCalculatorTypes.push({Id: 1, Name: 'MeetApp', Heading: t('VirtualMeetings.MeetAppLivePricingHeader'), Line1: t('VirtualMeetings.MeetAppLivePricingLine1'), Line2: t('VirtualMeetings.MeetAppLivePricingLine2'), Line3: t('VirtualMeetings.MeetAppLivePricingCurrentPrice'), Line4: t('VirtualMeetings.MeetAppLivePricingExample'), Line5: t('VirtualMeetings.MeetAppLivePricingExampleLine1'), Line6: t('VirtualMeetings.MeetAppLivePricingExampleLine2'), Line7: t('VirtualMeetings.MeetAppLiveExceedparticipanWarning'), Line8: t('VirtualMeetings.MeetAppLivePricingNoteLine')});

    this.arrPricingCalculatorTypes.push({Id: 2, Name: 'Vod', Heading: t('VirtualMeetings.VodPricingHeader'), Line1: t('VirtualMeetings.VodPricingLine1'), Line2: t('VirtualMeetings.VodPricingLine2'), Line3: t('VirtualMeetings.MeetAppLivePricingCurrentPrice'), Line4: t('VirtualMeetings.MeetAppLivePricingExample'), Line5: t('VirtualMeetings.MeetAppLivePricingExampleLine1'), Line6: t('VirtualMeetings.MeetAppLivePricingExampleLine2'), Line7: t('VirtualMeetings.VodExceedparticipanWarning'), Line8: t('VirtualMeetings.VodPricingNoteLine')});

    this.arrPricingCalculatorTypes.push({Id: 3, Name: 'Rtmp', Heading: t('VirtualMeetings.RtmpPricingHeader'), Line1: t('VirtualMeetings.RtmpPricingLine1'), Line2: t('VirtualMeetings.RtmpPricingLine2'), Line3: t('VirtualMeetings.MeetAppLivePricingCurrentPrice'), Line4: t('VirtualMeetings.MeetAppLivePricingExample'), Line5: t('VirtualMeetings.MeetAppLivePricingExampleLine1'), Line6: t('VirtualMeetings.MeetAppLivePricingExampleLine2'), Line7: t('VirtualMeetings.RtmpExceedparticipanWarning'), Line8: t('VirtualMeetings.VodPricingNoteLine')});

    this.arrPricingCalculatorTypes.push({Id: 4, Name: 'MeetAppLiveRecording', Heading: t('VirtualMeetings.MeetAppLiveRecordingPricingHeader'), Line1: t('VirtualMeetings.MeetAppLiveRecordingPricingLine1'), Line2: t('VirtualMeetings.MeetAppLiveRecordingPricingLine2'), Line3: t('VirtualMeetings.MeetAppLiveRecordingPricingCurrentPrice'), Line4: '', Line5: '', Line6: '', Line7: '', Line8: ''});
  }
}
